import { Controller, useFormContext } from "react-hook-form";
import { DateInput, DateInputProps } from "./date-input";

export type ControlledDateInputProps = Omit<
  DateInputProps,
  "onChange" | "value"
> & {
  name: string;
};

export function ControlledDateInput({
  name,
  ...props
}: ControlledDateInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        return (
          <DateInput
            {...props}
            {...field}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error?.message}
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
            }}
          />
        );
      }}
    />
  );
}
